/**
 * move banners into correct spots in wrapper
 */
(() => {
  const banner = document.querySelector('.homepage-banners');
  if (!banner) return;
  document.querySelector('.homepage-banners .left').appendChild(document.querySelector('.js-banner-left'));
  document.querySelector('.homepage-banners .center-1').appendChild(document.querySelector('.js-banner-1'));
  document.querySelector('.homepage-banners .center-2').appendChild(document.querySelector('.js-banner-2'));
  // document.querySelector('.homepage-banners .center-3').appendChild(document.querySelector('.js-banner-3'));
  // document.querySelector('.homepage-banners .center-4').appendChild(document.querySelector('.js-banner-4'));
  document.querySelector('.homepage-banners .right').appendChild(document.querySelector('.js-banner-right'));
})();